import { render, staticRenderFns } from "./appealOrder.vue?vue&type=template&id=130df2d8&scoped=true"
import script from "./appealOrder.vue?vue&type=script&lang=js"
export * from "./appealOrder.vue?vue&type=script&lang=js"
import style0 from "./appealOrder.vue?vue&type=style&index=0&id=130df2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130df2d8",
  null
  
)

export default component.exports